import { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Chip,
  Collapse,
  FormControl,
  Grid,
  ListItemText,
  Menu,
  MenuItem,
  Pagination,
  Paper,
  Select,
  SelectChangeEvent,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  useTheme
} from '@mui/material';
import useAuth from 'hooks/useAuth';
import MainCard from 'components/MainCard';
import { ArchiveBook, ArrowDown2, ArrowUp2, Calendar1, More, SearchNormal1, Send } from 'iconsax-react';
import IconButton from 'components/@extended/IconButton';
import { useNavigate } from 'react-router-dom';
import { getCourseCount, getCourseList, getWeeklyReport } from 'services/report.service';
import { useSelector } from 'react-redux';
import { dispatch } from 'store';
import {
  resetStatecoursereport,
  setSortCourse,
  setUserCourseSearch,
  setcoursereportPageIndex,
  setcoursereportTableSize,
  updatecoursereport
} from 'store/reducers/coursereport';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { OutlinedInput } from '@mui/material';
import Snackbar from 'utils/Snackbar';
import Loader2 from 'components/Loader2';
import { FormattedMessage } from 'react-intl';
import useConfig from 'hooks/useConfig';
import { formatDateBasedOnOrgSettings, getHourAsTimeZone } from 'utils/helper';
import CardTotalCount from 'components/cards/statistics/CardTotalCount';
import CustomTable from 'components/@extended/CustomTable';
import React from 'react';

const WeeklyReport = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { user, organization } = useAuth();
  const [weeklyData, setWeeklyData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openRow, setOpenRow] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleChange = (event: SelectChangeEvent<number>) => {
    setPageSize(+event.target.value);
    setCurrentPage(1);
  };
  const handlePageChange = (event: any, page: number) => {
    setCurrentPage(page);
  };
  const handleRowClick = (id: string) => {
    // console.log('id', id);
    setOpenRow(openRow === id ? null : id);
  };
  useEffect(() => {
    fetchWeeklyReport();
  }, [currentPage, pageSize]);
  useEffect(() => {
    return () => {
      dispatch(resetStatecoursereport());
    };
  }, [dispatch]);
  //   useEffect(() => {
  //     courseGet();
  //   }, []);

  const fetchWeeklyReport = async () => {
    setIsLoading(true);
    // let sort: any = {};
    // sortData.forEach((val: any) => {
    //   if (val.sort && val.desc) {
    //     sort[val.id] = -1;
    //   } else if (val.sort) {
    //     sort[val.id] = 1;
    //   } else {
    //     delete sort[val.id];
    //   }
    // });
    try {
      let reqData = {
        skip: currentPage,
        limit: pageSize
      };
      getWeeklyReport(reqData)
        .then((result) => {
          setIsLoading(false);
          // console.log('result?.data?.data?.data', result?.data?.data?.data);
          setCount(result?.data?.data?.count);
          setWeeklyData(result?.data?.data?.data);
          //   dispatch(updatecoursereport(result?.data?.data));
        })
        .catch((err) => {
          setIsLoading(false);
          if (err?.response?.status === 403) {
            const errorMessage = err?.response?.data?.message || "You don't have the required permissions to perform this action.";
            Snackbar(errorMessage, 'warning');
          } else {
            const errorMessage = err?.response?.data?.message || 'An unexpected error occurred. Please try again later.';
            Snackbar(errorMessage, 'error');
          }
        });
    } catch (error) {
      setIsLoading(false);
      console.error('Error fetching data:', error);
    }
  };

  return (
    <>
      {/* <MainCard title={<FormattedMessage id="Course Report" />}>
        <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'center' }}>
          {cardData.map((data, index) => (
            <Grid item xs={data.screen.xs} sm={data.screen.sm} md={data.screen.md} lg={data.screen.lg} key={index}>
              <CardTotalCount primary={data.value} secondary={data.name} />
            </Grid>
          ))}
        </Grid>
      </MainCard>
      <br /> */}
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box display={'flex'} flexDirection={'column'} justifyContent={'space-between'} gap={'5px'}>
            <MainCard
              title={
                <Typography variant="h5">
                
             
              <FormattedMessage id="Weekly Report List"/>
              </Typography>
              }
              content={false}
              sx={{
                '& .MuiCardHeader-root': {
                  padding: '7px 13px'
                }
              }}
            ></MainCard>
            <MainCard content={false}>
              <DndProvider backend={HTML5Backend}>
                {isLoading ? (
                  <Loader2 />
                ) : (
                  <Box>
                    <TableContainer component={Paper} sx={{ maxHeight: 370 }}>
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              sx={{
                                '&.MuiTableCell-root:not(:last-of-type)': {
                                  position: 'sticky',
                                  top: 0
                                }
                              }}
                            >
                              <FormattedMessage id="Class" />
                            </TableCell>
                            <TableCell
                              sx={{
                                '&.MuiTableCell-root:not(:last-of-type)': {
                                  position: 'sticky',
                                  top: 0
                                }
                              }}
                            >
                              <FormattedMessage id="class teacher" />
                            </TableCell>
                            <TableCell
                              sx={{
                                '&.MuiTableCell-root:not(:last-of-type)': {
                                  position: 'sticky',
                                  top: 0
                                }
                              }}
                            >
                              <FormattedMessage id="Total Students" />
                            </TableCell>
                            <TableCell
                              sx={{
                                '&.MuiTableCell-root:not(:last-of-type)': {
                                  position: 'sticky',
                                  top: 0
                                }
                              }}
                            >
                              <FormattedMessage id="ongoing courses Count" />
                            </TableCell>
                            <TableCell
                              sx={{
                                '&.MuiTableCell-root:not(:last-of-type)': {
                                  position: 'sticky',
                                  top: 0
                                }
                              }}
                            >
                              <FormattedMessage id="Weekly progress change Count" />
                            </TableCell>
                            <TableCell>
                              <FormattedMessage id="View Students" />
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {weeklyData && weeklyData.length > 0 ? (
                            weeklyData.map((batch: any) => {
                              const courseCount = batch?.users?.reduce((total: number, user: any) => {
                                return total + (user?.courses?.length || 0);
                              }, 0);
                              const progressCount = batch?.users?.reduce((total: number, user: any) => {
                                return total + (user?.courses ? user.courses.filter((course: any) => course.progressMade).length : 0);
                              }, 0);
                              // const allCourses = batch.users.flatMap((student: any) => student?.courses || []);
                              const allCourses = batch.users.flatMap(
                                (student: any) =>
                                  student?.courses?.map((course: string) => ({
                                    course,
                                    firstName: student?.firstName,
                                    lastName: student?.lastName
                                  })) || []
                              );

                              return (
                                <React.Fragment key={batch._id}>
                                  <TableRow>
                                    <TableCell>{batch?.classroom?.className}</TableCell>
                                    <TableCell sx={{ padding: '3px !important' }}>
                                      {batch?.classroom?.classTeacher ? (
                                        <Typography>
                                          {`${batch?.classroom?.classTeacher?.firstName || ''} ${
                                            batch?.classroom?.classTeacher?.lastName || ''
                                          }`}
                                        </Typography>
                                      ) : (
                                        '--'
                                      )}
                                    </TableCell>
                                    <TableCell sx={{ padding: '3px !important' }}>{batch?.users?.length || '0'}</TableCell>
                                    <TableCell sx={{ padding: '3px !important' }}>{courseCount || '0'}</TableCell>
                                    <TableCell sx={{ padding: '3px !important' }}>{progressCount || '0'}</TableCell>

                                    {/* <TableCell sx={{ padding: '3px !important' }}>{getTotalSubscribedCount(batch._id)}</TableCell> */}
                                    <TableCell sx={{ padding: '3px !important' }}>
                                      <IconButton size="small" onClick={() => handleRowClick(batch._id)}>
                                        {openRow === batch._id ? <ArrowUp2 /> : <ArrowDown2 />}
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell sx={{ padding: 0, border: 'none' }} colSpan={6}>
                                      <Collapse in={openRow === batch._id} timeout="auto" unmountOnExit>
                                        <Box>
                                          <Table size="small">
                                            <TableHead>
                                              <TableRow>
                                                <TableCell>
                                                  <FormattedMessage id="Name" />
                                                </TableCell>
                                                <TableCell>
                                                  <FormattedMessage id="Course" />
                                                </TableCell>
                                                <TableCell>
                                                  <FormattedMessage id="Progress" />
                                                </TableCell>
                                                <TableCell>
                                                  <FormattedMessage id="Status" />
                                                </TableCell>
                                                <TableCell>
                                                  <FormattedMessage id="Enrolled At" />
                                                </TableCell>
                                                <TableCell>
                                                  <FormattedMessage id="Last Updated At" />
                                                </TableCell>
                                                <TableCell>
                                                  <FormattedMessage id="Progress made this week?" />
                                                </TableCell>
                                              </TableRow>
                                            </TableHead>
                                            <>
                                              {allCourses.map((student: any) => {
                                                return (
                                                  <TableRow key={student.id}>
                                                    <TableCell sx={{ padding: '3px !important' }}>
                                                      {' '}
                                                      {student ? (
                                                        <Typography>{`${student?.firstName || ''} ${student?.lastName || ''}`}</Typography>
                                                      ) : (
                                                        '--'
                                                      )}
                                                    </TableCell>

                                                    <TableCell sx={{ padding: '3px !important' }}>
                                                      {student?.course?.courseId?.name || '--'}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '3px !important', textAlign: 'center' }}>
                                                      {student?.course?.progress || '0'}%
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '3px !important' }}>
                                                      {/* {student?.course?.status || '0'} */}
                                                      <>
                                                        {student?.course?.status === 'not started' ? (
                                                          <Chip
                                                            color="error"
                                                            variant="filled"
                                                            label={<strong> {student?.course?.status || '0'}</strong>}
                                                            size="small"
                                                          />
                                                        ) : student?.course?.status === 'in progress' ? (
                                                          <Chip
                                                            color="warning"
                                                            variant="filled"
                                                            label={<strong> {student?.course?.status || '0'}</strong>}
                                                            size="small"
                                                          />
                                                        ) : (
                                                          <Chip
                                                            color="success"
                                                            variant="filled"
                                                            label={<strong> {student?.course?.status || '0'}</strong>}
                                                            size="small"
                                                          />
                                                        )}
                                                      </>
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '3px !important' }}>
                                                      {formatDateBasedOnOrgSettings(student?.course?.enrollmentDate, organization) || '--'}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '3px !important' }}>
                                                      {formatDateBasedOnOrgSettings(student?.course?.updated_at, organization) || '--'}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '3px !important', textAlign: 'center' }}>
                                                      {student?.course?.progressMade ? '✔' : '❌'}
                                                    </TableCell>

                                                    <TableCell sx={{ padding: '0px !important' }}>
                                                      {/* {studentStatus.includes(student.id) ? (
                                                  <Chip
                                                    variant="filled"
                                                    size="small"
                                                    label={<FormattedMessage id="Subscribed" />}
                                                    color={studentStatus.includes(student.id) ? 'success' : 'default'}
                                                  />
                                                ) : (
                                                  '-'
                                                )} */}
                                                    </TableCell>
                                                  </TableRow>
                                                );
                                              })}
                                            </>
                                          </Table>
                                        </Box>
                                      </Collapse>
                                    </TableCell>
                                  </TableRow>
                                </React.Fragment>
                              );
                            })
                          ) : (
                            <Grid
                              container
                              direction="row"
                              justifyContent="center"
                              textAlign="center"
                              alignItems="center"
                              sx={{
                                height: '100%',
                                paddingTop: '50px',
                                paddingBottom: '50px',
                                marginLeft: { lg: '300px', md: '200px', sm: '100px', xs: '50px' }
                              }}
                            >
                              <Grid item xs={12}>
                                <Calendar1 size="200" color={theme.palette.primary.main} variant="Bold" />
                              </Grid>
                              <Grid item xs={12} margin={1}>
                                <Typography sx={{ fontWeight: 'bold' }}>{'No Week Reports Yet'}</Typography>
                              </Grid>
                            </Grid>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                )}
              </DndProvider>

              <Box sx={{ p: 1 }}>
                <Grid container alignItems="center" justifyContent="space-between" sx={{ width: 'auto' }}>
                  <Grid item>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="caption" color="secondary">
                          <FormattedMessage id="Row per page" />
                        </Typography>
                        <FormControl sx={{ m: 1 }}>
                          <Select
                            id="demo-controlled-open-select"
                            open={open}
                            onClose={handleClose}
                            onOpen={handleOpen}
                            value={pageSize}
                            onChange={handleChange}
                            size="small"
                            sx={{ '& .MuiSelect-select': { py: 0.75, px: 1.25 } }}
                          >
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={25}>25</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                          </Select>
                        </FormControl>
                      </Stack>
                    </Stack>
                  </Grid>
                  <Grid item sx={{ mt: { xs: 2, sm: 0 } }}>
                    <Pagination
                      onChange={handlePageChange}
                      count={Math.ceil(count / pageSize)}
                      page={currentPage}
                      variant="combined"
                      color="primary"
                    />
                  </Grid>
                </Grid>
              </Box>
            </MainCard>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default WeeklyReport;
